import { render, staticRenderFns } from "./NPendulum.vue?vue&type=template&id=bacc56dc&scoped=true&"
import script from "./NPendulum.vue?vue&type=script&lang=js&"
export * from "./NPendulum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacc56dc",
  null
  
)

export default component.exports